import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "switch_off",
  "use": "switch_off-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 15\" id=\"switch_off\"><path d=\"M11.58 2.712a.75.75 0 00-.981 1.136A5.479 5.479 0 0112.499 8c0 3.033-2.468 5.5-5.5 5.5a5.506 5.506 0 01-5.5-5.5 5.48 5.48 0 011.9-4.152.75.75 0 10-.981-1.136A6.985 6.985 0 000 8c0 3.86 3.141 7 7 7s7-3.14 7-7a6.98 6.98 0 00-2.42-5.288zM7 8.75A.75.75 0 007.75 8V1a.75.75 0 00-1.5 0v7c0 .414.336.75.75.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol